module.exports = __webpack_public_path__ + "static/media/dashboard-marker.95a440f3.svg";